<template>
    <div class="row h-100" @keydown="teamPropsApplyShortcut">
        <div id="team-nav-list" class="col-12 col-md-3">
            <div class="nav flex-column nav-pills h-100" role="tablist" aria-orientation="vertical">
                <a class="nav-link active" id="team-prop-general-tab" data-toggle="pill" href="#team-prop-general"
                   role="tab" aria-selected="true">General</a>
                <a class="nav-link" id="team-prop-advanced-tab" data-toggle="pill" href="#team-prop-advanced"
                   role="tab" aria-selected="false">Advanced</a>
                <a class="nav-link" id="team-prop-budget-tab" data-toggle="pill" href="#team-prop-budget"
                   role="tab" aria-selected="false">Budget</a>
                <a class="nav-link position-relative" id="team-prop-load-tab" data-toggle="pill" href="#team-prop-load"
                   role="tab" aria-selected="false" @click="updateLoadsGraph">Resource Heatmap<span class="badge badge-danger badge-new">New</span></a>
                <div class="flex-fill"></div>
                <BtnSubmit title="Apply" spinner ref="submitButton" :submitHandler="updateTeam" class="mt-5">
                </BtnSubmit>
            </div>
        </div>
        <div class="col-12 col-md-9 h-100 tab-content">
            <div class="tab-pane fade show active" id="team-prop-general" role="tabpanel">
                <div class="form-group">
                    <label for="modal-upd-team-name">Name</label>
                    <input type="text" class="form-control" id="modal-upd-team-name"
                           v-model="updTeamName"
                    >
                </div>
                <div class="form-group">
                    <label for="modal-upd-team-desc">Description</label>
                    <textarea class="form-control" id="modal-upd-team-desc" rows="3"
                              v-model="updTeamDesc"
                    ></textarea>
                </div>
            </div>
            <div class="tab-pane fade" id="team-prop-advanced" role="tabpanel">
                <h2 class="subhead text-danger">Delete team</h2>
                <p>
                    <button tabindex="-1" type="button" class="btn btn-sm btn-outline-danger float-right"
                            @click="removeTeam">Remove team</button>
                    Team will be deleted with all its projects and membership records.
                </p>
            </div>
            <div class="tab-pane fade" id="team-prop-budget" role="tabpanel">

                <div class="form-group">
                    <label for="team-prop-budget-billing">Billing Account</label>
                    <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle"
                                type="button"
                                id="team-prop-budget-billing"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ (selectedBilling ? selectedBilling.name : undefined) || 'Choose' }}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="team-prop-budget-billing">
                            <a class="dropdown-item" href="#"
                               v-for="billing in billingAccounts"
                               @click="selectBilling(billing)"
                            >{{ billing.name }}</a>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="team-prop-budget-charges">Charges</label>
                    <div class="help-text" id="team-prop-budget-charges">
                        {{ budget.charges }} credits
                    </div>
                </div>
            </div>
            <div class="h-100 tab-pane fade" id="team-prop-load" role="tabpanel">
                <CapacityHeatmap ref="capacityHeatmap"></CapacityHeatmap>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
  import CapacityHeatmap from './CapacityHeatmap.vue';
  import {handleXhrError, ShortcutHandler} from '../utils/Ui';
  import {MeBillingList, TeamRemove, TeamUpdate} from '../Routes';
  import {BillingDto, BudgetDto, BUDGET_DEFAULT, TeamDto} from '../Teams';
  import BtnSubmit from './BtnSubmit.vue';

  import $ from 'jquery';

  @Component({
    components: {BtnSubmit, CapacityHeatmap},
  })
  export default class TeamPropertiesPane extends Vue {
    @Prop()
    public onEditRefresh: () => void;
    @Prop()
    public onRemoveRefresh: () => void;
    @Prop()
    public team!: TeamDto;

    private budget = BUDGET_DEFAULT;
    private updTeamName = '';
    private updTeamDesc = '';
    private shortcutHandler = new ShortcutHandler();
    private billingAccounts: List<BillingDto> = [];
    private selectedBilling: BillingDto | null = null;

    public $refs!: {
      capacityHeatmap: CapacityHeatmap
    };

    constructor() {
      super();
    }

    public maxTabHeight(): number {
      const navListHeight = $("#team-nav-list").height();
      let maxTabHeight = 0;
      $(this.$el).find(".tab-pane").each((_, tab) => {
        maxTabHeight = Math.max(maxTabHeight, $(tab).height());
      });
      return Math.max(maxTabHeight, navListHeight);
    }

    public mounted() {
      this.shortcutHandler.register('Enter', this.updateTeam);
      MeBillingList.invoke(undefined)
        .then((result: List<BillingDto>) => {
          this.billingAccounts = result;
          this.onShown(this.team);
        }).fail((jqXhr) => handleXhrError(jqXhr, 'Failed to load billing accounts'));
    }

    public removeTeam() {
      TeamRemove.invoke({ teamRefid: this.team!!.refid })
        .done(() => {
          this.onRemoveRefresh();
        })
        .fail((jqXhr) => {
          handleXhrError(jqXhr, 'can\'t remove team');
        });
    }

    @Watch('team')
    public onShown(team: TeamDto | null) {
      if (team) {
        $('#modal-upd-team-name').trigger('focus');
        this.budget = team.budget ? team.budget : BUDGET_DEFAULT;
        this.updTeamName = team.name;
        this.updTeamDesc = team.description;
        this.selectedBilling = this.billingAccounts.find((it: BillingDto, idx: number, _) => {
          return it.refid === team.billingRefid;
        });
        if ($('#team-prop-load-tab').hasClass('active')) {
          this.updateLoadsGraph();
        }
      }
    }

    private updateTeam(): JQueryPromise<any> {
      return TeamUpdate.invoke({
        teamRefid: this.team!!.refid,
        name: this.updTeamName,
        description: this.updTeamDesc,
        billingRefid: this.selectedBilling?.refid
      }).done(() => {
        // this.showOwnedTeams();
        this.onEditRefresh();
      }).fail((jqXhr) => {
        handleXhrError(jqXhr, 'Failed to update team');
      });
    }

    public updateLoadsGraph() {
      this.$refs.capacityHeatmap.updateGraph(this.team);
    }

    private teamPropsApplyShortcut(e: KeyboardEvent) {
      this.shortcutHandler.handle(e);
    }

    private selectBilling(billing: BillingDto) {
      this.selectedBilling = billing;
    }
  }
</script>

<style scoped lang="scss">
    .badge-new {
      position: absolute;
      top: 0;
      right: 0;
    }
    h2 {
        margin-top: 0;
        padding-top: 1rem;
    }

    p {
        margin-bottom: 0;
    }
</style>
